<template>
  <v-row justify="center">
    <v-dialog :value="dialogRate" persistent>
      <v-card>
        <v-card-title class="headline">
          Информация по банковскому продукту
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="CloseRateWindow">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <template v-if="editedItemProduct != null">
            <v-simple-table fixed-header height="600px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Название параметра</th>
                    <th>Значение параметра</th>
                    <th>Пояснение</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="30%">
                      Название
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>Продукт</span>
                      </v-tooltip>
                    </td>
                    <td width="30%">{{ editedItemProduct.name }}</td>
                    <td width="40%">{{ editedItemProduct.name_note }}</td>
                  </tr>
                  <tr>
                    <td>Банк</td>
                    <td>{{ editedItemProduct.bank }}</td>
                    <td>{{ editedItemProduct.bank_note }}</td>
                  </tr>
                  <tr v-if="openedWebsite">
                    <td>Веб сайт</td>
                    <td>{{ openedWebsite }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Рейтинг</td>
                    <td>
                      <CalcRating
                        v-model="BankRate"
                        :bank_id="BankId"
                        :product_id="ProductId"
                        @closeDialog="CloseRateWindow()"
                      />
                    </td>
                    <td><a @click="RateMore()">Подробнее...</a></td>
                  </tr>
                  <tr>
                    <td>
                      Виды закупок
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указано, в соответствии с какими законами банк выдает
                          гарантии: №44-ФЗ «О контрактной системе в сфере
                          закупок товаров, работ, услуг для обеспечения
                          государственных и муниципальных нужд»; №223-ФЗ «О
                          закупках товаров, работ, услуг отдельными видами
                          юридических лиц»; №185-ФЗ «О Фонде содействия
                          реформированию жилищно-коммунального хозяйства» (и ПП
                          №615 «О порядке привлечения подрядных организаций для
                          оказания услуг и (или) выполнения работ по
                          капитальному ремонту общего имущества в
                          многоквартирном доме и порядке осуществления закупок
                          товаров, работ, услуг в целях выполнения функций
                          специализированной некоммерческой организации,
                          осуществляющей деятельность, направленную на
                          обеспечение проведения капитального ремонта общего
                          имущества в многоквартирных домах»; Гражданский кодекс
                          РФ.</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.purchase }}</td>
                    <td>{{ editedItemProduct.purchase_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Гарантия в пользу заказчика
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указано, в соответствии с какими законами банк выдает
                          гарантии: №44-ФЗ «О контрактной системе в сфере
                          закупок товаров, работ, услуг для обеспечения
                          государственных и муниципальных нужд»; №223-ФЗ «О
                          закупках товаров, работ, услуг отдельными видами
                          юридических лиц»; №185-ФЗ «О Фонде содействия
                          реформированию жилищно-коммунального хозяйства» (и ПП
                          №615 «О порядке привлечения подрядных организаций для
                          оказания услуг и (или) выполнения работ по
                          капитальному ремонту общего имущества в
                          многоквартирном доме и порядке осуществления закупок
                          товаров, работ, услуг в целях выполнения функций
                          специализированной некоммерческой организации,
                          осуществляющей деятельность, направленную на
                          обеспечение проведения капитального ремонта общего
                          имущества в многоквартирных домах»; Гражданский кодекс
                          РФ.</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.gar_polz_zak }}</td>
                    <td>{{ editedItemProduct.gar_polz_zak_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Ситуация у клиента
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Перечислены дополнительные факторы, которые могут
                          иметь значение при подборе банка для получения
                          гарантии</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.your_situation }}</td>
                    <td>{{ editedItemProduct.your_situation_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Виды гарантий:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Гарантия на участие – для обеспечения заявки при
                          проведении тендера, может потребоваться при всех видах
                          закупок (44-ФЗ, 223-ФЗ, 185-ФЗ, 615-ПП и т.д.).
                          Гарантия исполнения – обеспечение надлежащего
                          выполнения обязательств по контракту или договору,
                          который заключается по результатам проведения всех
                          видов закупок (44-ФЗ, 223-ФЗ, 185-ФЗ, 615-ПП и т.д.).
                          Гарантия возврата аванса – обеспечение обязательств по
                          возврату суммы аванса, который выплатит заказчик, если
                          такая гарантия будет предоставлена исполнителем
                          (специальный вид гарантии, применим только для
                          договоров по 223-ФЗ и при коммерческих закупках по ГК
                          РФ). Гарантия качества – обеспечение гарантийных
                          обязательств по контракту или договору перед
                          заказчиком (специальный вид гарантии, применим только
                          для договоров по 223-ФЗ и при коммерческих закупках по
                          ГК РФ). "
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.guarantee }}</td>
                    <td>{{ editedItemProduct.guarantee_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Способы направления заявки в банк:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указаны способы направления заявки на получения
                          гарантии в банк, а также подробности для каждого
                          способа. Оригиналы на бумаге – возможна подача заявки
                          традиционным способом (все документы распечатываются и
                          подписываются на бумаге), без применения электронной
                          подписи. КЭП – заявка подается с применением
                          квалифицированного сертификата электронной подписи.
                          Весь документооборот осуществляется в электронном
                          виде, дополнительно передавать в банк документы на
                          бумаге не требуется. КЭП + оригиналы на бумаге –
                          заявка подается с применением квалифицированного
                          сертификата электронной подписи, а затем некоторые
                          документы направляются в банк на бумаге. ЭП для торгов
                          по 44-ФЗ – возможна подача заявки с применением
                          усиленного неквалифицированного сертификата
                          электронной подписи. Весь документооборот
                          осуществляется в электронном виде, дополнительно
                          передавать в банк документы на бумаге не требуется. ЭП
                          для торгов по 44-ФЗ + оригиналы на бумаге – возможна
                          подача заявки с применением усиленного
                          неквалифицированного сертификата электронной подписи,
                          а затем некоторые документы направляются в банк на
                          бумаге."
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.request }}</td>
                    <td>{{ editedItemProduct.request_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Виды принципалов:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указано, каким видам принципалов банк предоставляет
                          гарантии: ИП – индивидуальным предпринимателям. ЮЛ –
                          юридическим лицам"
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.principal }}</td>
                    <td>{{ editedItemProduct.principal_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Расчетный счет:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указано, требуется ли обязательное открытие
                          расчетного счета в банке для получения банковской
                          гарантии.</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.account }}</td>
                    <td>{{ editedItemProduct.account_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Виды обеспечения:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указано, какие виды обеспечения могут потребоваться
                          для получения гарантии: Без обеспечения – банк
                          выпускает гарантию, не требуя вообще никакого
                          обеспечения по ней Поручительство – банк выпускает
                          гарантию под поручительство (одного или нескольких
                          физических и/или юридических лиц), обычно это
                          руководитель или лицо, владеющее 50% и более долей
                          компании. Залог – банк выпускает гарантию под залог
                          имущества (выручки по контракту, товаров, недвижимости
                          и т.п.), оценивается такое имущество обычно с
                          дисконтом. Депозит – банк выпускает гарантию под
                          внесение денежных средств на специальный счет, срок
                          депозита не менее срока действия гарантии. Вексель
                          банка – банк выпускает гарантию под залог своего
                          векселя."
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.bail }}</td>
                    <td>{{ editedItemProduct.bail_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Мин. срок гарантии, дней:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указан срок гарантии в днях, на который банк может
                          выдавать гарантии</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.mindays }}</td>
                    <td>{{ editedItemProduct.mindays_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Макс. срок гарантии, дней:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указан срок гарантии в днях, на который банк может
                          выдавать гарантии</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.maxdays }}</td>
                    <td>{{ editedItemProduct.maxdays_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Мин. сумма по одной гарантии на Принципала:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указана сумма в рублях по одной гарантии, которую
                          банк может выдавать</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.minsum }}</td>
                    <td>{{ editedItemProduct.minsum_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Макс. сумма по одной гарантии на Принципала
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указана сумма в рублях по одной гарантии, которую
                          банк может выдавать</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.maxsum }}</td>
                    <td>{{ editedItemProduct.maxsum_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Сумма по всем гарантиям Принципала в банке:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указана максимальная сумма в рублях по всем
                          одновременно действующим гарантиям, которые банк может
                          выдать на одного Принципала</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.allmaxsums }}</td>
                    <td>{{ editedItemProduct.allmaxsums_note }}</td>
                  </tr>
                  <tr>
                    <td>Тариф</td>
                    <td>{{ editedItemProduct.tariff }}</td>
                    <td>{{ editedItemProduct.tariff_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Установление лимита на Принципала:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указано, может ли банк установить лимит (т.е.
                          максимальную сумму, на которую будет готов выдавать
                          гарантии в течение определенного срока): Да –
                          заключается генеральное соглашение, в рамках действия
                          которого банк выдает принципалу гарантии в упрощенном
                          порядке по самому минимуму документов. При этом
                          указывается максимальный срок действия такого договора
                          (установленного лимита). Расчётно – на основании
                          анализа только финансовых документов клиента и его
                          опыта работы рассчитывается ориентировочный лимит, на
                          который может рассчитывать клиент, без подписания
                          официального соглашения. Нет – каждая заявка на выдачу
                          гарантии рассматривается в общем порядке, заранее
                          получить информацию о лимите от банка нельзя."
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.limit }}</td>
                    <td>{{ editedItemProduct.limit_note }}</td>
                  </tr>
                  <tr>
                    <!-- <td>
                      Условие о беccпорном списании
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small   v-on="on">info</v-icon>
                        </template>
                        <span>Указано, выдает ли банк гарантии с условием о бесспорном списании денежных средств со счета банка в пользу заказчика (бенефициара), а также как этот параметр влияет на комиссию за выдачу гарантии.</span>
                      </v-tooltip>
                    </td> -->
                    <td>{{ editedItemProduct.charge | toBool }}</td>
                    <td>{{ editedItemProduct.charge_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Условие о выплате аванса
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указано, выдает ли банк гарантии при наличии
                          признаков авансирования по контракту\договору, а также
                          как этот параметр влияет на комиссию за выдачу
                          гарантии.</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.prepaid | toBool }}</td>
                    <td>{{ editedItemProduct.prepaid_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Гарантия по форме заказчика
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указывается возможность выдачи гарантии по форме
                          заказчика "
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.form | toBool }}</td>
                    <td>{{ editedItemProduct.form_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Прочие условия:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указаны прочие условия, влияющие на окончательную
                          стоимость гарантии и условия ее выдачи ( снижение НМЦ,
                          регионы с повышенным риском и т.д.) "
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.other }}</td>
                    <td>{{ editedItemProduct.other_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Перевыпуск БГ
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указана возможность перевыпуска банковской гарантии,
                          возможность внесения изменений в гарантию и условия
                          внесения изменений</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.reloadbg }}</td>
                    <td>{{ editedItemProduct.reloadbg_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Срок существования клиента, мес.:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указаны требования банка к сроку фактической
                          деятельности или сроку существования Клиента (в
                          месяцах).</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.life }}</td>
                    <td>{{ editedItemProduct.life_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Опыт исполнения контрактов и/или договоров, шт.:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указаны требования банка к опыту исполнения
                          контрактов, договоров (в штуках) Клиентом по
                          информации из реестра контрактов/договоров,
                          размещенного в ЕИС.</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.practice }}</td>
                    <td>{{ editedItemProduct.practice_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Иные требования к принципалу и Стоп-факторы:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указывается, какие прочие требования к Принципалу
                          есть у банка. Также указываются стоп-факторы – т.е.
                          причины, которые могут повлечь отказ в выдаче гарантии
                          (финансовые показатели, кредитная история и
                          прочее)</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.stopfactor }}</td>
                    <td>{{ editedItemProduct.stopfactor_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Предварительное рассмотрение:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указывается возможность предварительного рассмотрения
                          Банком документов Принципала еще до его участия в
                          конкретной закупке для решения вопроса о том, сможет
                          ли Банк выдавать этому Принципалу соответствующую
                          гарантию или нет. Обязательно – предварительное
                          рассмотрение является стандартным этапом процедуры
                          выдачи гарантии в банке. Указываются документы,
                          необходимые для предварительного рассмотрения, или их
                          количество. Возможо – существует возможность получить
                          предварительный ответ от банка о целесообразности
                          подготовки полной заявки. Указываются документы,
                          необходимые для предварительного рассмотрения, или их
                          количество. Обычно это бухгалтерская отчетность и
                          информация об опыте исполнения контрактов. Нет –
                          заявка рассматривается только после сбора и
                          направления в банк полного пакета документов."
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.preview }}</td>
                    <td>{{ editedItemProduct.preview_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Пакет документов для получения гарантии:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указано, сколько документов требуется предоставить в
                          банк для получения банковской гарантии</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.packet }}</td>
                    <td>{{ editedItemProduct.packet_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Промежуточная управленческая отчетность ф.1 и ф.2 при УСН:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указано, требуется ли предоставление в банк от
                          Принципала, применяющего УСН, квартальной
                          управленческой отчетности по форме 1 "Бухгалтерский
                          баланс" и форме 2 "Отчет о финансовых результатах"
                          (скан-копия с подписью руководителя и
                          бухгалтера)</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.usn }}</td>
                    <td>{{ editedItemProduct.usn_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Промежуточная отчетность с отметкой ФНС:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указано, требуется ли предоставление в банк в составе
                          заявки какой-либо промежуточной отчетности Принципала
                          (за 1 квартал (код налогового периода «21»), за 2
                          квартал (код налогового периода «22») или за 3 квартал
                          (код налогового периода «33»)), с подтверждением о
                          сдаче и приеме ее в налоговой инспекции: Прибыль –
                          требуется предоставление декларации на прибыль НДС –
                          требуется предоставление декларации по НДС ЕНВД –
                          требуется предоставление квартальной декларации по
                          единому налогу на вмененный доход (если применяется
                          этот режим налогообложения) Не требуется – заявка
                          рассматривается без предоставления промежуточной
                          отчетности"
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.fns }}</td>
                    <td>{{ editedItemProduct.fns_note }}</td>
                  </tr>
                  <tr>
                    <td>Документы от сторонних организаций:</td>
                    <td>{{ editedItemProduct.third }}</td>
                    <td>{{ editedItemProduct.third_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Порядок подачи заявки, объем письма и использование
                      файлообменников:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указано, требуется ли предоставление в банк от
                          Принципала документов от сторонних организаций: Не
                          требуются – заявка рассматривается только по
                          документам клиента; Требуются - заявка рассматривается
                          только при предоставлении документов от сторонних
                          организаций: ФНС - требуются справки из ФНС;
                          Контрагенты - требуются благодарственные,
                          рекомендательные письма от контрагентов Банк -
                          требуются справки или иные документы из обслуживающих
                          банков"
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.method }}</td>
                    <td>{{ editedItemProduct.method_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Срок рассмотрения заявки:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span>
                          "Указано, регламентировано ли время рассмотрения
                          заявки на гарантию в банке, в течение которого банк
                          обязуется выдать свое решение о возможности выдачи
                          гарантии: Предварительное рассмотрение - скорринг по
                          базовым документам и сведениям Окончательное решение -
                          после получения полного пакета документов Не
                          регламентировано - отсутствуют четкие критерии времени
                          рассмотрения заявки в банке"
                        </span>
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.time }}</td>
                    <td>{{ editedItemProduct.time_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Порядок направления клиенту гарантии на бумаге:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указаны способы и условия отправки оригинала гарантии
                          на бумаге банком</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.paper }}</td>
                    <td>{{ editedItemProduct.paper_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      Особенности сотрудничества с банком-партнером:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указаны особенности, которые следует учитывать исходя
                          из условий договора с банком-партнером</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.osob }}</td>
                    <td>{{ editedItemProduct.osob_note }}</td>
                  </tr>
                  <tr v-if="role() !== roleObj.users">
                    <td>
                      {{
                        editedItemProduct.standart == 1
                          ? "Стандартные условия работы банка"
                          : `Акционные условия банка &nbsp; c ${editedItemProduct.saleDate[0]} по
                                            ${editedItemProduct.saleDate[1]}`
                      }}:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указана периодичность выплат и размер агентского
                          вознаграждения при стандартной комиссии банка, а также
                          по временной акции</span
                        >
                      </v-tooltip>
                    </td>
                    <td>
                      {{
                        editedItemProduct.what_fee === "range"
                          ? "АВ входит в комиссию"
                          : "АВ с превышения нетто"
                      }}
                    </td>
                    <td>{{ editedItemProduct.agentsfee_note }}</td>
                  </tr>
                  <tr v-if="role() !== roleObj.users">
                    <td>
                      Условия выплат агентам при снижении:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указана возможность и порядок снижения комиссии по
                          сравнению со стандартным тарифом, а также размер
                          вознаграждения Агента в этом случаяе</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.agentsdown }}</td>
                    <td>{{ editedItemProduct.agentsdown_note }}</td>
                  </tr>
                  <tr v-if="role() !== roleObj.users">
                    <td>
                      Условия выплат агентам при превышении:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указана возможность и порядок выставления повышенной
                          комиссии, превышающей стандартный тариф за выдачу
                          гарантии, а также размер вознаграждения Агента в этом
                          случае</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.agentsup }}</td>
                    <td>{{ editedItemProduct.agentsup_note }}</td>
                  </tr>
                  <tr>
                    <td>
                      ЭДО с агентом:
                      <v-tooltip right max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">info</v-icon>
                        </template>
                        <span
                          >Указана возможность и способ направления актов,
                          отчетов и счетов на оплату услуг агента с применением
                          электронного документооборота</span
                        >
                      </v-tooltip>
                    </td>
                    <td>{{ editedItemProduct.edo }}</td>
                    <td>{{ editedItemProduct.edo_note }}</td>
                  </tr>
                  <tr>
                    <td>Активно:</td>
                    <td>{{ editedItemProduct.active | toBool }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CalcRating from "@/components/CalcRating.vue";
import { roleObj } from "@/plugins/roles";

export default {
  props: ["editedItemProduct", "item"],
  components: { CalcRating },
  data: () => ({
    roleObj,
    agentTitle: "",
    agent: null,
    agentFee: null,
    agentUp: null,
    agentDown: null,
    openedWebsite: "",
  }),
  methods: {
    CloseRateWindow() {
      this.$store
        .dispatch("toggleRateViewWindow", false)
        .then(() => {})
        .catch((error) => {
          alert(error);
        });
    },
    RateMore() {
      this.CloseRateWindow();
      this.$router.push("/rating/userbank");
    },
    async getWebsites(idArr) {
      const { data } = await this.$store.dispatch(
        "getWebsite",
        JSON.parse(idArr)[0]
      );
      if (data) {
        this.openedWebsite = data.name;
      }
    },
  },
  computed: {
    dialogRate() {
      return this.$store.getters.getDialogRateView;
    },
    BankRate() {
      return this.$store.getters.get_bank_rate;
    },
    BankId() {
      return this.$store.getters.get_bank_id;
    },
    ProductId() {
      return this.$store.getters.get_product_id;
    },
  },
  filters: {
    toIndividual: function (value) {
      if (value == 0 || value == "0") return "индивидуально";
      return value;
    },
    toBool(val) {
      if (val) return "ДА";
      else return "Нет";
    },
  },
  mounted() {
    this.setTitle(`Информация по банковскому продукту`);
  },
  watch: {
    editedItemProduct(val) {
      this.getWebsites(val.website);
    },
  },
};
</script>

<style lang="scss">
#app {
  .theme--light.v-input:not(.v-input--is-disabled) input,
  .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: #217899;
  }

  h1 {
    font-size: 1.5rem;
  }

  .bluelink {
    color: #217899;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .v-data-table-header tr th {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .v-data-table-header tr th {
    font-size: 14px;
  }

  .v-dialog table thead tr th {
    font-size: 14px;
  }
}
</style>
